import React, { useEffect, useState, useRef } from 'react';
import { FaMicrophone, FaHeart } from 'react-icons/fa';
import { FaLocationDot } from 'react-icons/fa6';
import { IoMdClose } from 'react-icons/io';
import { IoSearch } from 'react-icons/io5';
import { Link, useNavigate } from 'react-router-dom';
import './../../Assets/CSS/Header.css';
import styles from './../../Assets/CSS/Modal.module.css';
import { BlueButton } from './../../Components/Button';
import inputStyles from './../../Assets/CSS/Input.module.css';
import { toast } from 'react-toastify';
import axios from 'axios';
import { BASE_URL, BASE_FILE_URL } from './../../Environment';
 
function Header() {
    const navigate = useNavigate();
    const token = localStorage.getItem('accessToken');
    const [setting, setSetting] = useState([]);
    const [profile_page, setProfilePage] = useState('');
    const [show_location, setShowLocation] = useState(false);
    const [isLocationLoading, setIsLocationLoading] = useState(false);
    const [location_data, setLocationData] = useState('');
    const location = localStorage.getItem('location');
    const [location_list, setLocationList] = useState([]);
    const [listing, setListing] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [isListening, setIsListening] = useState(false); 
    const [filteredListings, setFilteredListings] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isResRightVisible, setIsResRightVisible] = useState(false);
    const [popupAd, setPopupAd] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [isMuted, setIsMuted] = useState(false);
    const popupVideoRef = useRef(null);
    useEffect(() => {
        const value = localStorage.getItem('loginAs');
        if (value === 'User') setProfilePage('/user/profile');
        if (value === 'Client') setProfilePage('/client/profile');
        if (value === 'Agent') setProfilePage('/agent/profile');
        if (!location) setShowLocation(true);
        axios.get(`${BASE_URL}/setting`).then(res => {
            setSetting(res.data.data);
        }).catch(res => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
        });  
        axios.get(`${BASE_URL}/location`).then(res => {
            setLocationList(res.data.data);
        }).catch(res => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
        });
        axios.get(`${BASE_URL}/popup-ad`).then(res => {
            if (res.data.data) {
                setPopupAd(res.data.data);
                setShowPopup(true);
            }
        }); 
    }, []);
    useEffect(() => {
        setIsLoading(true);
        axios.get(`${BASE_URL}/get-all-listing/${location}`).then(res => {
            setListing(res.data.data);
            setIsLoading(false);
        }).catch(res => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
            setIsLoading(false);
        });
    }, [location]);
    const handleSearchChange = (event) => {
        const value = event.target.value;
        setSearchText(value);
    };
    const handleVoiceSearch = () => {
        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        if (!SpeechRecognition) {
            toast.error('Voice search is not supported in your browser.', { autoClose: 3000 });
            return;
        }
        const recognition = new SpeechRecognition();
        recognition.lang = 'en-IN';
        recognition.interimResults = false;
        recognition.onstart = () => setIsListening(true);
        recognition.onresult = (event) => {
            const transcript = event.results[0][0].transcript;
            setSearchText(transcript);
        };
        recognition.onerror = () => setIsListening(false);
        recognition.onend = () => setIsListening(false);
        recognition.start();
    }; 
    useEffect(() => {
        if (searchText === '') {
            setFilteredListings([]);
        } else {
            const filtered = listing.filter(item =>
                item.category.name.toLowerCase().includes(searchText.toLowerCase()) ||
                item.sub_category.name.toLowerCase().includes(searchText.toLowerCase()) ||
                item.sub_sub_category.name.toLowerCase().includes(searchText.toLowerCase()) ||
                item.name.toLowerCase().includes(searchText.toLowerCase()) ||
                item.description.toLowerCase().includes(searchText.toLowerCase())
            );  
            setFilteredListings(filtered);
        }
    }, [searchText, listing]);
    const onChangeRegister = (event) => {
        const value = event.target.value;
        navigate(`/${value.toLowerCase()}/register`);
    }
    const onChangeLogin = (event) => {
        const value = event.target.value;
        navigate(`/${value.toLowerCase()}/login`);
    }
    const handleLogout = () => {
        ['loginAs', 'accessToken'].forEach(item => localStorage.removeItem(item));
        window.location.reload();
    }
    const handleMenu = (page) => navigate(page);
    const selectLocation = () => {
        setIsLocationLoading(true);
        if (location_data) {
            localStorage.setItem('location', location_data);
            setIsLocationLoading(false);
            setShowLocation(false);
        } else {
            toast.error('Select your location first.', { autoClose: 3000 });
            setIsLocationLoading(false);
        }
    }
    const handleChange = () => {
        localStorage.removeItem('location');
        setShowLocation(true);
    }
    const onDetails = (u_id) => {
        setSearchText('');
        navigate(`/listing-details/${u_id}`);
    }
    const toggleResRight = () => setIsResRightVisible(!isResRightVisible); 
    const closeMenu = () => setIsResRightVisible(false);
    const handlePopupVideoRef = (el) => {
        if (el && !el._attempted) {
            el._attempted = true;
            popupVideoRef.current = el;
            el.muted = false;
            el.play().catch(() => {
                el.muted = true;
                setIsMuted(true);
                el.play();
            });
        }
    };
    const handleUnmute = () => {
        setIsMuted(false);
        if (popupVideoRef.current) {
            popupVideoRef.current.muted = false;
        }
    };
    const CustomSearchableDropdown = ({ options, onSelect, value }) => {
        const [search, setSearch] = useState(value || '');
        const [showDropdown, setShowDropdown] = useState(false);
        useEffect(() => {
            setSearch(value || '');
        }, [value]);
        const filteredOptions = options.filter(opt =>
            opt.location.toLowerCase().includes(search.toLowerCase())
        ); 
        const handleSelect = (value) => {
            setSearch(value);
            onSelect(value);
            setShowDropdown(false);
        }; 
        return (
            <div style={{ position: 'relative' }}>
                <input
                    type="text"
                    className={inputStyles.input}
                    value={search}
                    onChange={(e) => {
                        setSearch(e.target.value);
                        setShowDropdown(true);
                    }}
                    onFocus={() => setShowDropdown(true)}
                    placeholder='Search or Select Location'
                />
                {showDropdown && filteredOptions.length > 0 && (
                    <ul style={{
                        listStyle: 'none',
                        margin: 0,
                        padding: 0,
                        position: 'absolute',
                        zIndex: 1000,
                        backgroundColor: '#fff',
                        border: '1px solid #ccc',
                        width: '100%',
                        maxHeight: '150px',
                        overflowY: 'auto',
                    }}>
                        {filteredOptions.map((loc, index) => (
                            <li
                                key={index}
                                onClick={() => handleSelect(loc.location)}
                                style={{
                                    padding: '8px',
                                    cursor: 'pointer',
                                    borderBottom: '1px solid #eee',
                                }}
                            >
                                {loc.location}
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        ); 
    }; 
    return (
        <>
            {showPopup && popupAd && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.7)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 99999 }}>
                    <div style={{ position: 'relative', borderRadius: 12, overflow: 'hidden', maxWidth: 400 }}>
                        <button onClick={() => setShowPopup(false)} style={{ position: 'absolute', top: 8, right: 8, background: 'rgba(0,0,0,0.6)', color: 'white', border: 'none', borderRadius: '50%', width: 30, height: 30, cursor: 'pointer', fontSize: 16, zIndex: 1 }}>✕</button>
                        {isMuted && (
                            <button onClick={handleUnmute} style={{ position: 'absolute', bottom: 12, right: 12, background: 'rgba(0,0,0,0.7)', color: 'white', border: '1px solid rgba(255,255,255,0.5)', borderRadius: 8, padding: '6px 14px', cursor: 'pointer', fontSize: 14, zIndex: 1, display: 'flex', alignItems: 'center', gap: 6 }}>
                                🔇 Tap to Unmute
                            </button>
                        )}
                        <video ref={handlePopupVideoRef} playsInline onEnded={() => setShowPopup(false)} style={{ width: '100%', display: 'block' }}>
                            <source src={`${BASE_FILE_URL}${popupAd.video}`} type="video/mp4" />
                        </video>
                    </div>
                </div>
            )} 
            <header>
                {show_location &&
                    <div className={styles.successModalContainer}>
                        <h4 className="mb-4">Select Location</h4>
                        <h5 className="mb-2">Location *</h5>
                        <CustomSearchableDropdown
                            options={[{ location: 'All Location' }, ...location_list]} 
                            onSelect={(value) => setLocationData(value)} 
                            value={location_data}  
                        />
                        <br />
                        <div className={styles.row}>
                            <BlueButton title={isLocationLoading ? "Loading..." : "Submit"} onClick={selectLocation} />
                        </div>
                    </div>
                }
                <div className="header-child">
                    <div>
                        <span><FaHeart color="red" size={16} /></span>
                        <span className="mx-2">OUR RESPONSIBILITIES FOR OUR COUNTRY</span>
                        <span><FaHeart color="red" size={16} /></span>
                    </div>
                </div>
                <div className="main_header">
                    <div className="left">
                        <div className="headerLogoContainer">
                            <Link to="/">
                                <img src={setting.logo ? BASE_FILE_URL + setting.logo : null} className="headerLogo" alt="logo" />
                            </Link>
                        </div>
                        <div className="dropdowns ms-5">
                            <select name="downloadApp" className="dropdown" onChange={(e) => { if(e.target.value) { window.open(e.target.value, '_blank'); e.target.selectedIndex = 0; } }}>
                                <option value="">Install App</option> 
                                <option value="https://play.google.com/store/apps/details?id=com.infomart.app">Android</option>
                            </select> 
                            <select name="register" className="dropdown" onChange={onChangeRegister}>
                                <option>Register</option>
                                <option>User</option>
                                <option>Client</option>
                                <option>Agent</option>
                            </select>
                            {token ? (
                                <button className="logoutBtn" onClick={handleLogout}>Logout</button>
                            ) : (
                                <select className="dropdown" onChange={onChangeLogin}>
                                    <option>Login</option>
                                    <option>User</option>
                                    <option>Client</option>
                                    <option>Agent</option>
                                </select>
                            )}
                        </div>
                    </div>
                    <button className='tog-btn' onClick={toggleResRight}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-justify-right" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M6 12.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-4-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5m0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5m0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5" />
                        </svg>
                    </button>
                    <div className={`right ${isResRightVisible ? 'res-right' : ''}`}>
                        <div className="top">
                            <ul>
                                <li>
                                    <Link to="/" onClick={closeMenu}>Home</Link>
                                    {/* <Link to="/free-ads">Free Ads</Link> */}
                                    <Link to="/blood" onClick={closeMenu}>Blood</Link>
                                    {token && <Link to={profile_page} onClick={closeMenu}>Profile</Link>}
                                </li>
                            </ul>
                        </div>
                        <div className="bottom">
                            <div className="inputContainer">
                                <input type="text" className="input" value={searchText} placeholder="Search..." onChange={handleSearchChange} />
                                <FaMicrophone color={isListening ? "red" : "rgb(18,95,220)"} style={{ cursor: 'pointer', marginRight: 8 }} onClick={handleVoiceSearch} />
                                <IoSearch color="rgb(18,95,220)" />
                            </div> 
                            {searchText && (
                                <div className="search-suggestions">
                                    {isLoading ? (
                                        <h5 className="text-center mt-5 mb-5">Loading...</h5>
                                    ) : filteredListings.length > 0 ? (
                                        <ul>
                                            {filteredListings.map((item, index) => (
                                                <li key={index} onClick={() => onDetails(item.u_id)}>
                                                    <div className="ms-4 me-4">
                                                        <h5>{item.name} ({item.sub_sub_category.name})</h5> 
                                                        <p className="mb-0">{item.house_no}, {item.road_name}, {item.district}, {item.state}, {item.pincode}</p>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <h6 className="text-center mt-5 mb-5">No results found.</h6>
                                    )}
                                </div>
                            )}
                            <div className="row">
                                <div className="inputContainer location">
                                    <FaLocationDot color="rgb(18,95,220)" />
                                    <input type="text" className="input" value={location || ''} placeholder="Enter Your City" readOnly />
                                    <IoMdClose className="closeBtn" onClick={handleChange} />
                                </div>
                            </div> 
                        </div>
                    </div>
                </div>
            </header>
        </> 
    );
}
  
export default Header; 